import Joi from "joi-browser";

let schema = Joi.object().keys({
  name: Joi.string().required(),
  description: Joi.string().required(),
});
schema = schema.optionalKeys('name', 'description');
export default schema;
